(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('race-positions', {
            parent: 'entity',
            url: '/race-positions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.racePositions.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race-positions/race-positions.html',
                    controller: 'RacePositionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('racePositions');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('race-positions-detail', {
            parent: 'race-positions',
            url: '/race-positions/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.racePositions.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race-positions/race-positions-detail.html',
                    controller: 'RacePositionsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('racePositions');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RacePositions', function($stateParams, RacePositions) {
                    return RacePositions.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'race-positions',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('race-positions-detail.edit', {
            parent: 'race-positions-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-positions/race-positions-dialog.html',
                    controller: 'RacePositionsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RacePositions', function(RacePositions) {
                            return RacePositions.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race-positions.new', {
            parent: 'race-positions',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-positions/race-positions-dialog.html',
                    controller: 'RacePositionsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                longitude: null,
                                latitude: null,
                                time: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('race-positions', null, { reload: 'race-positions' });
                }, function() {
                    $state.go('race-positions');
                });
            }]
        })
        .state('race-positions.edit', {
            parent: 'race-positions',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-positions/race-positions-dialog.html',
                    controller: 'RacePositionsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RacePositions', function(RacePositions) {
                            return RacePositions.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race-positions', null, { reload: 'race-positions' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race-positions.delete', {
            parent: 'race-positions',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-positions/race-positions-delete-dialog.html',
                    controller: 'RacePositionsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RacePositions', function(RacePositions) {
                            return RacePositions.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race-positions', null, { reload: 'race-positions' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
